export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const googleLoginApiSrc = process.env.REACT_APP_GOOGLE_LOGIN_API_SRC;

export const googleLoginApiClientID = process.env.REACT_APP_GOOGLE_LOGIN_API_CLIENT_ID;

export const wsURL = process.env.REACT_APP_API_WS_URL;

export const shopifyAppStoreURL =
  process.env.REACT_APP_SHOPIFY_APP_STORE_URL || "https://apps.shopify.com/orderlink";
